import { mobiClient } from '@/services/axiosConfig'
import { InitKycSession, SendOtp, SendOtpResponse, Validate, ValidateKycSession, ValidateRegno, VerifyOtp, VerifyOtpResponse } from './types'
import { DanValidateRegnoRes, DanValidateRes, InitKycSessionRes, ValidateKycSessionRes } from '../dan/types'

export const sendOtp = async (req: SendOtp): Promise<SendOtpResponse | undefined> => {
  console.log('send info', req)
  try {
    const res = await mobiClient.post('/dan/sendOtp', req)
    return res.data
  } catch (e: any) {
    return e.response.data
  }
}

export const verifyOtp = async (req: VerifyOtp): Promise<VerifyOtpResponse | undefined> => {
  console.log('verify info..', req)
  try {
    const res = await mobiClient.post('/dan/verifyOtp', req)
    console.log('res', res)
    return res.data
  } catch (e: any) {
    console.log('e', e.response.data)
    return e.response.data
  }
}

export const validate = async (req: Validate): Promise<DanValidateRes | undefined> => {
  console.log('validate info..', req)
  try {
    const res = await mobiClient.post('/dan', req)
    console.log('res', res)
    return res.data
  } catch (e: any) {
    console.log('e', e.response.data)
    return e.response.data
  }
}

export const validateRegno = async (req: ValidateRegno): Promise<DanValidateRegnoRes | undefined> => {
  console.log('validate regno info..', req)
  try {
    const res = await mobiClient.post('/dan/validate-regno', req)
    console.log('res', res)
    return res.data
  } catch (e: any) {
    console.log('e', e.response.data)
    return e.response.data
  }
}

export const initKycSession = async (req: InitKycSession): Promise<InitKycSessionRes | undefined> => {
  console.log('validate regno info..', req)
  try {
    const res = await mobiClient.post('/dan/kyc/init', req)
    console.log('res', res)
    return res.data
  } catch (e: any) {
    console.log('e', e.response.data)
    return e.response.data
  }
}

export const validateKycSession = async (req: ValidateKycSession): Promise<ValidateKycSessionRes | undefined> => {
  console.log('validate regno info..', req)
  try {
    const res = await mobiClient.post('/dan/kyc/validate', req)
    console.log('res', res)
    return res.data
  } catch (e: any) {
    console.log('e', e.response.data)
    return e.response.data
  }
}